import { render } from "./registrationStep4.vue?vue&type=template&id=46439724&scoped=true"
import script from "./registrationStep4.vue?vue&type=script&lang=js"
export * from "./registrationStep4.vue?vue&type=script&lang=js"

import "./registrationStep4.vue?vue&type=style&index=0&id=46439724&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46439724"]])

export default __exports__